import React, { useState } from "react";
import { ToastMessage } from "../../../global/ToastMessage";
import { FPermisoStyle } from "./styles";
import { Button, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { asignarRolPermisosAction } from "../../../ducks/rolDuck";
import HeaderModal from "../../../global/headerModal";
import BackDrop from "../../../global/BackDrop";
import ModalBase from "../../../global/ModalBase";
import TransferList from "../../../global/TransferList";
const Modal = (props) => {
  const { open = true, setOpen = () => {}, rowData = { Id: 0 } } = props;

  const dispatch = useDispatch();
  const classes = FPermisoStyle();
  const [isLoad, setIsLoad] = useState(false);
  const [asignado, setAsignado] = useState([]);
  const onGuardar = (values) => {
    setIsLoad(true);
    let payload = {
      IdRol: rowData.Id,
      Permisos: asignado,
    };
    dispatch(asignarRolPermisosAction(payload)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  };

  const LimpiarForm = () => {
    setAsignado([]);
  };
  const handleClose = () => {
    setOpen(!open);
    LimpiarForm();
  };

  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={`Permisos para ${rowData.Name}`}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12}>
          <TransferList idRol={rowData.Id} setAsignado={setAsignado} />
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={onGuardar}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
};
export default Modal;
